import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch.jsx";

class LegacyApiService {
  constructor(client) {
    this.client = client;
    this.baseUrl = Angie.api_url;
  }

  get(url) {
    return this.client({ url: `${this.baseUrl}${url}` });
  }

  post(url, data, config = {}) {
    return this.client({
      url: `${this.baseUrl}${url}`,
      method: "POST",
      body: data,
      ...config,
    });
  }

  put(url, data, config = {}) {
    return this.client({
      url: `${this.baseUrl}${url}`,
      method: "PUT",
      body: data,
      ...config,
    });
  }

  delete(url, config = {}) {
    return this.client({
      url: `${this.baseUrl}${url}`,
      method: "DELETE",
      ...config,
    });
  }
}

export default new LegacyApiService(fetch);
